import settings from 'configurations/application';

import happen from './happen';

const validation = {
  password: (password: string): boolean =>
    happen(password.length).between(settings.fields.password.validation.MIN, settings.fields.password.validation.MAX),
};

export default validation;
